/* eslint-disable react/jsx-pascal-case */
import './App.css'
import { BrowserRouter as Router, Link } from 'react-router-dom';
import loadingimg from './assets/loading_bird.gif'
import { useState, useEffect, Suspense, lazy } from 'react';
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box } from "@mui/material";
import useWindowDimensions from './components/tool/useWindowDimensions.js';
import RoutesConfig from './components/tool/Routes.jsx';
import Cookies from 'js-cookie';
import { useSubdomain } from './context/SubdomainContext';
const StyledContent = styled("div")(({ theme }) => ({
  fontFamily:"Montserrat,sans-serif",
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));
function App() {
  const { subdomain } = useSubdomain();
  const [isTenant, setIsTenant] = useState(null);
  const [isCheckingTenant, setIsCheckingTenant] = useState(false);
  const { width }  = useWindowDimensions()
  const style = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width:"100vw",
    height: "100vh",
  }
  useEffect(() => {
    const checkTenant = () => {
      if (!subdomain) {
        setIsTenant(null);
        return;
      }

      setIsCheckingTenant(true);

      fetch(process.env.REACT_APP_BACKEND + subdomain + '/auth/checktenant')
        .then((res) => {
          if(res.status === 200){
            return res.json()
          }else{
            throw new Error('Network response was not ok')
          }
        }).then((data) => {
          if(data.tenant){
            setIsTenant(true)
            getSession();
          }else{
            setIsTenant(false)
          }

        })
        .catch((err) => {console.log("Error: " + err); setIsTenant(false);})
        .finally(() => setIsCheckingTenant(false));
    };

    const getSession = async () => {
      try {
          const res = await fetch(process.env.REACT_APP_BACKEND + subdomain + '/auth/authenticate/', {
              credentials: "include",
          });
          const data = await res.json();
          if (res.status === 200 || res.status === 202) {
              if (data.is_authenticated) {
                  Cookies.set("csrftoken", data.csrftoken, { path: '/' });
                  return true;
              } else {
                  return false;
              }
          } else {
              console.log("Network response was not ok");
              return false;
          }
      } catch (err) { console.log("session not created") }
    }

    checkTenant();
  },[subdomain])
  // "REACT_APP_BACKEND": "http://192.168.29.64:8000/api/", (env file's prop)
  return (
    <Router>
    <div className='main_container'>
      {width < 0
       ? (
        <div className='indication_msg'>
          <Typography variant="h5" paragraph sx={{color: "white", fontFamily: "Montserrat, sans-serif" }}>
                  Expand your window above <span>768pixels</span> to view the tool
          </Typography>
        </div>
      ) : (
        isCheckingTenant ? (
          <div className='loading_img_container' style={style}><img src={loadingimg} alt='loading'/></div>
        ) : (
          isTenant === false ? (
            <Container sx={{ width: "100vw", height: "100vh" }}>
              <StyledContent sx={{ textAlign: "center", alignItems: "center" }}>
                <Typography variant="h4" paragraph sx={{ color: "violet", fontFamily: "Montserrat, sans-serif" }}>
                  Sorry, tenant not found!
                </Typography>
                <Typography sx={{ color: "white", fontFamily: "Montserrat, sans-serif" }}>
                  Sorry, we couldn’t find the tenant you’re looking for. Perhaps you’ve mistyped the tenant name? Be sure to check your spelling.
                </Typography>
                <Box
                  component="img"
                  src="https://minimal-kit-react.vercel.app/assets/illustrations/illustration_404.svg"
                  sx={{ height: 260, mx: "auto", my: { xs: 5, sm: 10 } }}
                />
                <Link underline="hover" color="inherit" href="https://www.whizzc.com/">
                  <Button
                    to="/d-error-404-page-not-foundd"
                    size="large"
                    variant="contained"
                    sx={{
                      backgroundColor: "violet",
                      color: "#160430",
                      ":hover": {
                        backgroundColor: "violet",
                        opacity: "80%"
                      }
                    }}
                  >
                    Go to whizzc
                  </Button>
                </Link>
              </StyledContent>
            </Container>
          ) : (
            <Suspense fallback={<div className='loading_img_container' style={style}><img src={loadingimg} alt='loading'/></div>}>
              <RoutesConfig/>
            </Suspense>
          )
        )
      )}
    </div>

  </Router>
  )
}

export default App;
